module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    ref: "setHomework",
    staticClass: "setHomework"
  }, 'div', _vm.$attrs, false), [_vm._m(0), _vm._v(" "), _c('setBooks', {
    attrs: {
      "loadData": _vm.loadData
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n    布置作业\n    "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/step2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', [_vm._v("作业留言")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c717db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/setHomework.vue
// module id = 1169
// module chunks = 1